/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { ApplicationOverride } from '../models/ApplicationOverride';
import { Pagination } from '../models/Pagination';

export class ListApplicationOverrideResponse {
  'applicationOverrides'?: Array<ApplicationOverride>;
  'pagination'?: Pagination;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "applicationOverrides",
      "baseName": "applicationOverrides",
      "type": "Array<ApplicationOverride>",
      "format": ""
    },
    {
      "name": "pagination",
      "baseName": "pagination",
      "type": "Pagination",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListApplicationOverrideResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

